import { useCallback, useState } from "react";
import { searchTabsEnum } from "../../Tabs";

interface IUseTabs {
  initialTab: searchTabsEnum;
}

export const useTabs = ({ initialTab }: IUseTabs) => {
  const [tab, setTab] = useState<searchTabsEnum>(initialTab);

  const onTabChange = useCallback((tab: searchTabsEnum) => {
    setTab(tab);
  }, []);

  return {
    tab,
    onTabChange
  };
};
